import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import server from "../../functions/server";
import "./styles.css";
import {
  AppBar,
  Box,
  CircularProgress,
  Toolbar,
  Typography,
} from "@mui/material";
import Cookies from "js-cookie";
import { supportNumber } from "../../utils/supportNumber";

function VerificaCertificado() {
  const [situacao, setSituacao] = useState("");
  const [loading, setLoading] = useState(true);
  const [params] = useSearchParams();

  const codprod = params.get("codprod");
  const serie = params.get("serie");
  const series = params.get("series");
  const bu = params.get("bu");
  const cnpj = params.get("cnpj");

  const options = useMemo(() => {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + Cookies.get("bearer"),
      },
      body: new URLSearchParams({
        codprod,
        serie,
      }),
    };
  }, [codprod, serie]);

  const codes = useMemo(() => {
    return series.split(",");
  }, [series]);

  const capitalizeBu = useMemo(() => {
    if (!bu) return "";

    return bu?.charAt?.(0)?.toUpperCase?.() + bu?.slice?.(1);
  }, [bu]);

  const handleGetSituacao = useCallback(async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${server}portalCliente/valida_certificado`,
        options
      );

      const data = await response.json();

      const dateParts = data.situacao.split("/");

      const months = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];
      const month = months[parseInt(dateParts[1], 10) - 1];

      const formattedDate = `${dateParts[0]}, de ${month} de ${dateParts[2]}`;
      setSituacao(formattedDate?.trim?.());
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [options]);

  useEffect(() => {
    handleGetSituacao();
  }, [handleGetSituacao]);

  if (loading) {
    return (
      <>
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="fixed" color="default">
            <Toolbar
              sx={{
                pr: "24px",
                justifyContent: "space-between",
              }}
            >
              <Typography
                component="div"
                variant="div"
                color="inherit"
                alignItems="flex-start"
                sx={{ ml: 2 }}
              >
                <img
                  height={35}
                  alt="Logo MedSystems"
                  src={`${server}arquivos/img/medsystems.png`}
                />
              </Typography>
            </Toolbar>
          </AppBar>
        </Box>
        <div className="certificate_loading">
          <CircularProgress />
        </div>
      </>
    );
  }

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="fixed" color="default">
          <Toolbar
            sx={{
              pr: "24px",
              justifyContent: "space-between",
            }}
          >
            <Typography
              component="div"
              variant="div"
              color="inherit"
              alignItems="flex-start"
              sx={{ ml: 2 }}
            >
              <img
                height={35}
                alt="Logo MedSystems"
                src={`${server}arquivos/img/medsystems.png`}
              />
            </Typography>
          </Toolbar>
        </AppBar>
      </Box>
      <>
        <div className="certificate_container">
          <img
            src="/portal/certificateBanner.png"
            alt="banner"
            className="certificate_banner"
          />

          <section className="certificate_content">
            {situacao ? (
              <>
                <h1>
                  Validação do Certificado de Autenticidade {capitalizeBu}
                </h1>

                <div>
                  <p>
                    {codes?.length === 1
                      ? "O consumível com o código"
                      : "Os consumíveis com os códigos"}
                  </p>
                  {codes.map((code, index) => (
                    <div className="certificate_codes_container">
                      <span span key={code} className="certificate_codes">
                        {code.replace(/"/g, "")}
                        {index < codes.length - 1 ? ", " : ""}
                      </span>
                    </div>
                  ))}
                  <p className="certificate_date">
                    {codes?.length === 1
                      ? `está autenticado até ${situacao}.`
                      : `estão autenticados até ${situacao}.`}
                  </p>

                  <p className="certificate_ask">
                    Em caso de dúvidas, entre em contato através do número:{" "}
                    {supportNumber.phone} ou através do whastapp:
                  </p>
                </div>
              </>
            ) : (
              <>
                <h1>O certificado da clínica {cnpj} está expirado!</h1>

                <p className="certificate_contacts">
                  Entre em contato com nosso atendimento através do telefone
                  {supportNumber.phone} para renovar o certificado de
                  autenticidade, ou clique abaixo:
                </p>
              </>
            )}

            <div className="certificate_whatsapp_container">
              <a
                href={`https://wa.me/${supportNumber.whatsApp}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <div className="whatsApp_button">
                  <img
                    src="/portal/whatsapp.png"
                    alt=""
                    className="certificate_whatsApp"
                  />
                  <p>Atendimento ao cliente</p>
                </div>
              </a>
            </div>
            <hr />

            <p className="certificate_info">
              Cartuchos falsos, recarregados, modificados ou reconfigurados não
              possuem controle de segurança, amparo técnico ou regulatório, e
              podem gerar riscos para a saúde do paciente. Use somente o
              original!
            </p>
            <h3>#EuApoioEssaCampanha</h3>
            <h2>GRUPO MEDSYSTEMS</h2>
          </section>
        </div>

        <footer className="certificate_footer">
          <div className="certificate_content" />
        </footer>
      </>
    </>
  );
}

export default VerificaCertificado;
